// extracted by mini-css-extract-plugin
module.exports = {"linkBank":"styles_linkBank__2Xtkn","text":"styles_text__3Yjyn","odd":"styles_odd__2B6FI","even":"styles_even__3ckVe","link":"styles_link__QI8fI"};